import { Categories } from "../data/Categories";
import { Link } from "react-router-dom";
import React from 'react'

function CategoryList() {
  return (
    <div className="mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 items-center max-w-screen-2xl px-4">
      {Categories.map((cat, index) => (
        <Link
          key={index}
          to={`/category/${cat.name.toLowerCase()}`}
          className="group flex flex-col items-center bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
        >
          {/* Image Container */}
          <div className="relative w-full aspect-square overflow-hidden bg-gray-50">
            <img 
              src={cat.image} 
              alt={cat.name} 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
            />
            {/* Overlay Gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
          
          {/* Label */}
          <div className="py-3 px-2 w-full text-center">
            <p className="text-xs font-bold text-gray-800 uppercase tracking-wider group-hover:text-green-600 transition-colors">
              {cat.name}
            </p>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default CategoryList